/*
  ------------------------------------------------------------------
  BNZ LP : vidéos de fond
  Les vidéos sont rendues en preload="none" : rien n'est téléchargé
  tant qu'elles ne croisent pas le viewport. À l'entrée on bascule en
  preload="auto" puis on lance la lecture, à la sortie on met en pause. Sur une page qui en empile
  plusieurs, c'est ce qui évite de faire descendre plusieurs flux en
  parallèle.

  Le réglage « mouvement réduit » du système coupe la lecture
  automatique et rend les contrôles natifs.
  ------------------------------------------------------------------
*/
(function () {
  var REDUCED_MOTION =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function play(video) {
    var attempt = video.play();
    // Un navigateur peut refuser la lecture (onglet en arrière-plan,
    // économie de données) : la promesse rejetée n'est pas une erreur.
    if (attempt && attempt.catch) attempt.catch(function () {});
  }

  function initVideos(root) {
    var videos = root.querySelectorAll('video[data-bnz-lp-video]');

    Array.prototype.forEach.call(videos, function (video) {
      if (video.dataset.bnzLpReady) return;
      video.dataset.bnzLpReady = 'true';

      // muted en attribut ne suffit pas partout : on force la propriété,
      // sans quoi iOS refuse la lecture automatique.
      video.muted = true;

      if (REDUCED_MOTION) {
        video.setAttribute('controls', '');
        video.preload = 'metadata';
        return;
      }

      if (!('IntersectionObserver' in window)) {
        video.preload = 'auto';
        play(video);
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              if (video.preload !== 'auto') video.preload = 'auto';
              play(video);
            } else if (!video.paused) {
              video.pause();
            }
          });
        },
        { threshold: 0.1 }
      );

      observer.observe(video);
      video.bnzLpObserver = observer;
    });
  }

  function initSound(root) {
    var buttons = root.querySelectorAll('[data-bnz-lp-sound]');

    Array.prototype.forEach.call(buttons, function (button) {
      if (button.dataset.bnzLpReady) return;
      button.dataset.bnzLpReady = 'true';

      button.addEventListener('click', function () {
        var wrap = button.closest('[data-bnz-lp-video-wrap]');
        var video = wrap && wrap.querySelector('video[data-bnz-lp-video]');
        if (!video) return;

        video.muted = !video.muted;
        button.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
        button.setAttribute(
          'aria-label',
          video.muted ? button.dataset.labelOn : button.dataset.labelOff
        );

        // Le clic est un geste utilisateur : c'est le bon moment pour
        // relancer une vidéo que l'observateur aurait mise en pause.
        if (video.paused) play(video);
      });
    });
  }

  function init(root) {
    var scope = root || document;
    initVideos(scope);
    initSound(scope);
  }

  window.BnzLp = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // Éditeur de thème : la section est réinjectée, ses vidéos sont neuves.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
